<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ 'users.membershipCard' | translate }}</h4>
      <button type="button" class="close" aria-label="Close" mat-dialog-close>
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">

      <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>
      <ng-container *ngIf='!dataLoading'>
        <div id="cardElement" #cardElement>
          <div class="membership-card">
            <div class="right-side">
              <img class="logo-placeholder" src="./assets/images/logo-section.svg" />
            </div>
            <div class="left-side">
              <div class="user-info-header">
                <svg xmlns="http://www.w3.org/2000/svg" width="3" height="44" viewBox="0 0 3 44">
                  <g id="Line" transform="translate(-1106.035 -237)">
                    <rect id="line-dark-mint" width="3" height="43.564" rx="1.5" transform="translate(1106.035 237.436)"
                      fill="#4ea5a5" />
                    <rect id="line-mint" width="3" height="33.603" rx="1.5" transform="translate(1106.035 237)"
                      fill="#6be2b7" />
                  </g>
                </svg>
                <div class="user-info-content">
                  <div class="user-name">{{membershipInfo.fullName}}</div>
                  <div class="user-role">
                    <ng-container *ngIf="membershipInfo.membershipType == userTypeEnum.Ambassador">
                      سفير
                    </ng-container>
                    <ng-container *ngIf="membershipInfo.membershipType == userTypeEnum.Member">
                      عضو
                    </ng-container>
                  </div>
                </div>
              </div>

              <div class="details-list">
                <div class="details-item">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12.002" height="9" viewBox="0 0 12.002 9">
                      <path id="membership-number"
                        d="M5138.5,20632a2.5,2.5,0,0,1-2.5-2.5v-4a2.5,2.5,0,0,1,2.5-2.5h7a2.5,2.5,0,0,1,2.5,2.5v4a2.5,2.5,0,0,1-2.5,2.5Zm-1.5-6.5v4a1.5,1.5,0,0,0,1.5,1.5h7a1.5,1.5,0,0,0,1.5-1.5v-4a1.5,1.5,0,0,0-1.5-1.5h-7A1.5,1.5,0,0,0,5137,20625.5Zm3.563,4.645a.463.463,0,0,1-.394-.523l.1-.725h-.942l-.119.854a.461.461,0,0,1-.456.4c-.026,0-.046,0-.067,0a.465.465,0,0,1-.394-.523l.1-.725h-.585a.461.461,0,0,1,0-.922h.715l.14-.953h-.642a.461.461,0,1,1,0-.922h.771l.124-.854a.464.464,0,0,1,.456-.395.264.264,0,0,1,.067.006.459.459,0,0,1,.393.523l-.1.719h.938l.124-.854a.464.464,0,0,1,.456-.395.241.241,0,0,1,.067.006.459.459,0,0,1,.394.523l-.1.719h.58a.461.461,0,1,1,0,.922h-.715l-.134.953h.642a.461.461,0,1,1,0,.922h-.771l-.125.854a.461.461,0,0,1-.456.4C5140.6,20630.15,5140.582,20630.146,5140.561,20630.146Zm-1.1-2.17h.942l.135-.953h-.942Zm4.039,2.025a.5.5,0,1,1,0-1h1a.5.5,0,0,1,0,1Zm0-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Zm0-2a.5.5,0,1,1,0-1h2a.5.5,0,0,1,0,1Z"
                        transform="translate(-5135.999 -20623)" fill="#bdced9" />
                    </svg>
                  </span>
                  <span class="label">رقم العضوية:</span>
                  <span class="value">{{membershipInfo.membershipNumber}}</span>
                </div>
                <div class="details-item">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10">
                      <path id="id-card"
                        d="M2.5,5.75A1.25,1.25,0,1,1,3.75,7,1.25,1.25,0,0,1,2.5,5.75ZM12,9.5v-5A2.5,2.5,0,0,0,9.5,2h-7A2.5,2.5,0,0,0,0,4.5v5A2.5,2.5,0,0,0,2.5,12h7A2.5,2.5,0,0,0,12,9.5ZM9.5,3A1.5,1.5,0,0,1,11,4.5v5A1.5,1.5,0,0,1,9.5,11h-7A1.5,1.5,0,0,1,1,9.5v-5A1.5,1.5,0,0,1,2.5,3ZM10,5a.5.5,0,0,0-.5-.5H7a.5.5,0,0,0,0,1H9.5A.5.5,0,0,0,10,5Zm0,2a.5.5,0,0,0-.5-.5H7a.5.5,0,0,0,0,1H9.5A.5.5,0,0,0,10,7ZM9,9a.5.5,0,0,0-.5-.5H7a.5.5,0,0,0,0,1H8.5A.5.5,0,0,0,9,9Zm-3.9.49A.5.5,0,0,0,5.49,8.9a1.781,1.781,0,0,0-3.479,0,.5.5,0,1,0,.979.2.782.782,0,0,1,1.521,0A.5.5,0,0,0,5.1,9.49Z"
                        transform="translate(0 -2)" fill="#bdced9" />
                    </svg>
                  </span>
                  <span class="label">رقم الهوية:</span>
                  <span class="value">{{membershipInfo.identityNumber}}</span>
                </div>
                <div class="details-item">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                      <path id="calendar-day"
                        d="M4,6H3A1,1,0,0,0,2,7V8A1,1,0,0,0,3,9H4A1,1,0,0,0,5,8V7A1,1,0,0,0,4,6ZM9.5,1H9V.5a.5.5,0,0,0-1,0V1H4V.5a.5.5,0,0,0-1,0V1H2.5A2.5,2.5,0,0,0,0,3.5v6A2.5,2.5,0,0,0,2.5,12h7A2.5,2.5,0,0,0,12,9.5v-6A2.5,2.5,0,0,0,9.5,1Zm-7,1h7A1.5,1.5,0,0,1,11,3.5V4H1V3.5A1.5,1.5,0,0,1,2.5,2Zm7,9h-7A1.5,1.5,0,0,1,1,9.5V5H11V9.5A1.5,1.5,0,0,1,9.5,11Z"
                        fill="#bdced9" />
                    </svg>
                  </span>
                  <span class="label">تاريخ الانضمام:</span>
                  <span class="value">{{membershipInfo.joinedDate | date:'dd/MM/yyyy' }}</span>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-btns">
            <button type="reset" class="close closebtn" aria-label="Close" mat-dialog-close>
              <span>{{ 'users.Cancel' | translate }}</span>
            </button>
            <button mat-raised-button class="btn customBtn" (click)="print()" [ngClass]="{ 'loading': loading}"
              [disabled]="loading">
              {{ 'meetings.Print' | translate }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
